export const LEFT_NAV_BAR_WIDTH = "340px";

export const TEXT_INPUT_COLUMN_WIDTH = "350px";
